import axios from "axios"
import {isRequestError, RequestError} from "../../Model/RequestError";
import {acceptHeader, jsonContentTypeHeader, executeWithErrorResponseHandling} from "../ApiUtilities";
import {joinUrl} from "../../Utilities/UriUtilities";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";
import {ExistsResponse} from "../../Model/Sales/CustomerExistsResponse";

/**
 * Function is responsible for calling the customerProfile API, which will return information on the customer when
 * queried with an email address
 */
export const isEmailAssociatedWithCustomer = async (
    domain: string,
    emailAddress: string
): Promise<ExistsResponse | RequestError> => {
    const endpoint = joinUrl(domain, `/customerProfile/exists`)
    const headers = {...acceptHeader(), ...jsonContentTypeHeader()}

    const response = await executeWithErrorResponseHandling<ExistsResponse>(() =>
        axios.post(endpoint, {email: emailAddress}, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/customerProfile/exists", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/customerProfile/exists", "status": "success"}})
        return response.data
    }
}
